import {
  Box,
  Chip,
  Divider,
  FormControlLabel,
  FormHelperText,
  Radio,
  TextareaAutosize,
  styledComponent
} from '@hermes/web-components'

export const RadioStyled = styledComponent(Radio)(({ theme }) => ({
  paddingRight: '12px',
  '&:hover': {
    backgroundColor: 'transparent'
  },
  span: {
    svg: {
      width: '20px',
      height: '20px',
      fill: theme.palette.primary.main
    }
  }
}))

export const ChipStyled = styledComponent(Chip)(() => ({}))
export const FormHelperTextStyled = styledComponent(FormHelperText)(({ theme }) => ({
  padding: '4px 0 0 0',
  margin: 0,
  fontSize: '14px',
  color: theme.palette.primary[600]
}))

export const FormControlLabelStyled = styledComponent(FormControlLabel)(() => ({
  padding: 0,
  margin: 0,
  width: '100%',
  alignItems: 'flex-start'
}))

export const DividerStyled = styledComponent(Divider)(() => ({
  margin: '12px 0 12px 0',
  height: '1px'
}))

export const GroupContainer = styledComponent(Box)(({ theme }) => ({
  padding: 0,
  margin: 0,
  width: '100%',
  [theme.breakpoints.down('xs')]: {
    padding: '16px 16px 0'
  }
}))

export const TextArea = styledComponent(TextareaAutosize)(({ theme }) => ({
  boxSizing: 'border-box',
  fontFamily: theme.typography.body1.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.body1.fontWeight,
  letterSpacing: theme.typography.body1.letterSpacing,
  lineHeight: 1.5,
  backgroundColor: 'transparent',
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  borderRadius: '10px',
  border: `1px solid ${theme.palette.neutral[200]}`,
  padding: '12px',
  color: theme.palette.neutral[900],
  background: 'transparent',

  '&:hover': {},

  '&:focus': {
    outline: 0,
    border: `1px solid ${theme.palette.secondary.main}`
  },

  '&:focus-visible': {
    outline: 0
  }
}))
